<script>
    import Header from '../global/header.svelte'
</script>

<style>
    h1 {
        font-size:27px;
        font-size: 2.7rem;
        line-height: 27px;
        font-weight: 300;
    }

    .method {
        font-size:13px;
        font-size: 1.3rem;
    }

    .method h2 {
        color: var(--brand-color);
        font-size:25px;
        font-size: 2.5rem;
        margin-bottom: .25em;
        font-weight: 300;
    }

    .actions {
        margin: 2em 0;
    }
    .actions a {
 
        margin-bottom: 1em;
  
    }
     .actions .alt {
         background: var(--dark-color);
     }

     h4 {
         font-size: 15px;
         font-size: 1.5rem;
         font-weight: 300;
     }

     p {
         margin:0
     }

</style>


<svelte:head>
    <title>Contact Page</title>
</svelte:head>

<Header title="Contact us" url="/" /> 

<section>
    <div>
        <h1>Member Support<br/>
        Southern Co-op<br/>
        1000 Lakeside<br/>
        Western Road<br/>
        Portsmouth<br/>
        Hampshire<br/>
        PO6 3FE<br/><br/>
        Sat Nav use: PO6 3EN
    </div>

    <div class="method"> 
        <h2>Telephone:</h2>
        <p>0800 652 0124</p>
    </div>

    <div class="method"> 
        <h2>Email:</h2>
        <p>membersupport@southerncoops.co.uk</p>
    </div>

    <div class="actions">
        <a class="btn btn--dark" target="_blank" href="mailto:membersupport@southerncoops.co.uk">Send us a message</a>
        <h4>Learn more about our other businesses</h4>
        <a class="btn" target="_blank" href="https://www.thesouthernco-operative.co.uk/food/">Food</a>
        <a class="btn" target="_blank" href="https://www.funeralcare.co.uk/">Funeralcare</a>
        <a target="_blank" class="terms" href="/terms">Terms & conditions</a> | <a target="_blank" href="https://www.thesouthernco-operative.co.uk/membership/wp-content/uploads/2019/06/SC-Privacy-Notice-26.04.20191.pdf">Privacy notice</a>
    </div>

</section>
